import { render, staticRenderFns } from "./fourPage.vue?vue&type=template&id=faccab8e&scoped=true"
import script from "./fourPage.vue?vue&type=script&lang=js"
export * from "./fourPage.vue?vue&type=script&lang=js"
import style0 from "./fourPage.vue?vue&type=style&index=0&id=faccab8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faccab8e",
  null
  
)

export default component.exports